/* This example requires Tailwind CSS v2.0+ */
import React, { Fragment } from 'react';
import { Transition } from '@headlessui/react';

export const Backdrop = ({ onClick, bgColor }) => {
  return (
    <Transition
      as={Fragment}
      enter='ease-out duration-500'
      enterFrom='opacity-0'
      enterTo='opacity-100'
      leave='ease-in duration-200'
      leaveFrom='opacity-100'
      leaveTo='opacity-0'>
      <button
        type='button'
        onClick={onClick}
        className={`fixed h-screen w-screen -z-1 inset-0 cursor-pointer ${bgColor} bg-opacity-75 backdrop-filter  backdrop-blur-sm transition-opacity`}
      />
    </Transition>
  );
};
